module.exports = __webpack_public_path__ + "img/downimg.6050dbc3.jpg";